declare var ExcelJS: any;
declare var saveAs: any;
var printExport = (function () {
    let pageHeight = 1120;
    let pageWidth = 790;

    var getTab = function (tab: WorkbookTab, widgetId: number) {
        let result = null;
        let submitObject = {
            tabId: tab.id(),
            workbookId: workbook.workbookConfig.workbookId(),
            resetDrilldown: false,
            isExcelCSV: workbook.workbookConfig.isExcelPrinting,
            widgetId: widgetId,
            scheduledEmailId: workbook.workbookConfig.scheduledEmailId,
            isEmailBody: workbook.workbookConfig.isEmailBody,
        };

        let o = {
            url: urlConfigs.tabs + "GetTab",
            data: submitObject,
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (data, e) {
            result = data;
        };

        irGlobal.requestServer(o);

        return result;
    }
    var createWidget = function ($reportContent: JQuery<HTMLElement>, tab: WorkbookTab, isLandscape: boolean,
        $context: JQuery<HTMLElement> = undefined, widgetId: number = 0) {
        let $widget = $("widget");
        if ($context) {
            $widget = $("widget", $context);
        }

        if ($widget.length) {
            let result = getTab(tab, widgetId);
            let dashboardWidget: DashboardWidget = null;
            if (widgetId !== 0 && tab.dashboard) {
                dashboardWidget = tab.dashboard.widgets().find(x => x.id() === widgetId);
            }

            let reportWidget = BaseWidget.createWidget(null, tab, dashboardWidget, result.widgetType);
            reportWidget.setResultAndConfig(result);
            if (result.widgetType === WidgetType.Chart) {
                //Set the width and height of the chart to the width of the PDF. Decreased the height of the chart when in landscape.
                let infoTable = $widget.siblings("#infotable");
                let height = isLandscape ? pageWidth - infoTable.outerHeight(true) - 90 : pageWidth; 
                $widget.width(pageWidth).height(height).css("display", "block");
            }

            ko.applyBindings({ config: workbook.workbookConfig, widget: reportWidget }, $widget.get(0));
        }
    }

    var createDashboard = function (tab: WorkbookTab, isLandscape: boolean, $context: JQuery<HTMLElement> = undefined) {
        let $dashboard = $("dashboard");
        if ($context) {
            $dashboard = $("dashboard", $context);
        }

        let dashboard = tab.dashboard;
        ko.applyBindings({ config: workbook.workbookConfig, printing: true, dashboard: dashboard }, $dashboard.get(0));

        let scrollLimit = dashboard.getScrollLimit();
        
        $dashboard.css({ width: `${(scrollLimit.maxWidth + 5)}px`, height: `${(scrollLimit.maxHeight + 5)}px` });

        //#infinite-scrollbar
        //Lines removed
    }

    var print = function (workbookId: number, tabId: number, widgetId: number = 0, scheduledEmailId: number = null) {
        workbook.exportPrintSetup(workbookId, tabId, widgetId, false, scheduledEmailId);
        workbook.workbookConfig.isPrinting = true;

        let tab = workbook.workbookConfig.tabs().find(x => x.id() === tabId);

        createWidget($("div.reportContent"), tab, false, undefined, widgetId);

        var readyToPrint = function () {
            if (reportsReady) {
                if (reportsReady() === true) {
                    window.print();
                }
                else {
                    setTimeout(readyToPrint, 1000);
                }
            }
            else {
                window.print();
            }
        }
        setTimeout(readyToPrint, 1000);
    };

    var printDashboard = function (workbookId: number, tabId: number, scheduledEmailId: number = null) {
        exportDashboardToPDFPrint(workbookId, tabId, true, scheduledEmailId);

        var readyToPrint = function () {
            if (reportsReady) {
                if (reportsReady() === true) {
                    window.print();
                }
                else {
                    setTimeout(readyToPrint, 1000);
                }
            }
            else {
                window.print();
            }
        }
        setTimeout(readyToPrint, 1000);
    }

    var exportWorkbookToPDF = function (workbookId: number, isLandscape: boolean, scheduledEmailId: number = null) {
        workbook.exportPrintSetup(workbookId, 0, undefined, false, scheduledEmailId);
        workbook.workbookConfig.isPrinting = true;

        for (let tab of workbook.workbookConfig.tabs()) {
            let $tab = $(`#tab_${tab.id()}`);
            if (tab.tabType() === TabTypeEnum.Dashboard) {
                createDashboard(tab, isLandscape, $tab);
            }
            else {
                createWidget($("div.reportContent", $tab), tab, isLandscape, $tab);
            }
        }
    }

    var exportDashboardToPDF = function (workbookId: number, tabId: number, isLandscape: boolean, scheduledEmailId: number = null) {
        exportDashboardToPDFPrint(workbookId, tabId, isLandscape, scheduledEmailId);
    }
    var exportDashboardToPDFPrint = function (workbookId: number, tabId: number, isLandscape: boolean, scheduledEmailId: number = null) {
        workbook.exportPrintSetup(workbookId, tabId, undefined, false, scheduledEmailId);
        workbook.workbookConfig.isPrinting = true;

        createDashboard(workbook.workbookConfig.activeTab(), isLandscape)
    };

    var exportToPDF = function (workbookId: number, tabId: number, isLandscape: boolean, widgetId: number, scheduledEmailId: number = null) {
        workbook.exportPrintSetup(workbookId, tabId, widgetId, false, scheduledEmailId);
        workbook.workbookConfig.isPrinting = true;

        let tab = workbook.workbookConfig.tabs().find(x => x.id() === tabId);

        createWidget($("div.reportContent"), tab, isLandscape, undefined, widgetId);
    };

    var exportToXLSXCSV = function (workbookId: number, tabId: number, widgetId: number, scheduledEmailId: number = null) {
        workbook.exportPrintSetup(workbookId, tabId, widgetId, true, scheduledEmailId);
        workbook.workbookConfig.isExcelPrinting = true;

        let tab = workbook.workbookConfig.tabs().find(x => x.id() === tabId);

        createWidget($("div.reportContent"), tab, false, undefined, widgetId);
    };

    var exportReportToExcel = function (e, gridComponent = null, context = null) {
        let settings = {
            isCSV: false,
            withoutHeaders: false,
            printMessage: "",
            mappingName: "",
            workbookName: "",
            tabName: "",
            widgetName: "",
            reportName: "",
            groupBy: "",
            orderBy: "",
            filters: "" as any,
            companyName: "",
            fontSize: 0,
            glReport: false,
            subtotalsPosition: TotalsPositionEnum.None,
            save: false,
            fileName: "",
            currencyCode: "",
            subTotalText: "",
            formattingRules: undefined,
            showReportRowCount: false,
            analyzeByTop: "",
            groupByTop: ""
        };
        $.extend(settings, e);

        //file name has a limit of 31 characteres
        const fileName = settings.reportName?.length > 30 ? settings.reportName.substring(0, 29) : settings.reportName;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(fileName);
        const component = gridComponent || $('.gridContainer').data("dxDataGrid");
        if (component === null || component === undefined) {
            return;
        }

        let def = $.Deferred();
        let skip = 1;
        if (!settings.withoutHeaders) {
            skip = 6;
            if (settings.widgetName) {
                skip++;
            }
            if (settings.groupBy) {
                skip++;
            }
            if (settings.orderBy) {
                skip++;
            }
            if (settings.companyName && settings.companyName !== "") {
                skip++;
            }

            if (typeof settings.filters === "string" && settings.filters !== "") {
                settings.filters = JSON.parse(settings.filters);
                skip += settings.filters.length;
            }
            else {
                if (settings.filters === "" || settings.filters === undefined || settings.filters === null)
                    settings.filters = [];

                skip += settings.filters.length;
            }
        }

        let result = { } as any;
        let widget = context ? $("widget", context) : $("widget");
        if (widget.length) {
            result = ko.dataFor(widget.get(0))?.widget?.result;
        }
        
        let formattingRules = result.formattingRules || settings.formattingRules;
        let subtotalsPosition = result.subtotalsPosition || settings.subtotalsPosition;
        let isGlReport = result.glReport || settings.glReport;
        let currencyCode = result.currencyCode || settings.currencyCode;
        let subTotalText = result.subTotalText || settings.subTotalText;
        let showReportRowCount = result.showReportRowCount || settings.showReportRowCount;

        let rowIndex = 0;
        let rowNumber = -1;

        let default_report_colour = $("html").css("--default_report_colour").replace("#", "").trimStart();
        let default_report_odd_colour = $("html").css("--default_report_odd_colour").replace("#", "").trimStart();
        let default_headfoot_font_colour = $("html").css("--default_headfoot_font_colour").replace("#", "").trimStart();
        let default_headfoot_colour = $("html").css("--default_headfoot_colour").replace("#", "").trimStart();

        let totalItems = component.option("summary.totalItems");
        let totalItemsUpdated = false;
        let rowsToRemove = [];
        let rowsCollapsed = [];
        let rowsToReplaceSubtotalText = [];
        let rowsToApplyBorderWhenSubTotalIsTop = [];

        let columns = component.option("columns");
        setExcelColumnFormat(columns, currencyCode);

        const borderStyle = { style: 'thin', color: { argb: 'black' } };

        let groupIndex = 0;
        const addIdentation = function (val, spaces) {
            for (var i = 0; i < spaces; i++) {
                val = `    ${val}`;
            }

            return val;
        }

        let applyFormattingRule = function (formattingScale, excelCell, forceApply: boolean) {
            if (formattingScale) {
                let colors = getFormattingScaleColor(formattingScale);
                if (colors.backgroundColor && colors.backgroundColor.toLowerCase() !== "#ffffff") {
                    let applyColor = !excelCell.fill || excelCell.fill.isDefault;

                    if (applyColor || forceApply) {
                        excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: colors.backgroundColor.replace("#", "") } };
                    }
                }

                if (colors.color) {
                    let applyColor = !excelCell.font?.color || excelCell.font.color.isDefault;

                    if (applyColor || forceApply) {
                        excelCell.font.color = { argb: colors.color.replace("#", "") };
                    }
                }
            }
        }.bind(this)
        let cellsToApplyFormattingRule = {};
        let customExport = function () {
            DevExpress.excelExporter.exportDataGrid({
                component: component,
                worksheet,
                topLeftCell: { row: skip, column: 1 },
                customizeCell(this: ReportWidget, options) {
                    const { gridCell } = options;
                    const { excelCell } = options;
                    excelCell.font = excelCell.font || {};
                    excelCell.font.size = settings.fontSize;
                    excelCell.font.color = { isDefault: true };

                    if (!settings.isCSV && (gridCell.rowType === "totalFooter" || gridCell.rowType === "groupFooter" || gridCell.rowType === "group" || gridCell.rowType === 'data')) {
                        if (!cellsToApplyFormattingRule[excelCell.fullAddress.row]) {
                            cellsToApplyFormattingRule[excelCell.fullAddress.row] = {
                                formattingRuleScale: [],
                                cells: []
                            };
                        }

                        cellsToApplyFormattingRule[excelCell.fullAddress.row].cells.push({ gridCell, excelCell });
                    }

                    if (gridCell.column.name === "fake") {
                        excelCell.value = "";
                    }

                    let column = gridCell.column as any;

                    //Hack to remove currency format
                    if (settings.isCSV && column.isMetric &&
                        (gridCell.rowType === "totalFooter" || gridCell.rowType === "groupFooter" || gridCell.rowType === "group")) {
                        if (gridCell.value !== undefined) {
                            excelCell.value = gridCell.value.toString();
                        }
                        else if (gridCell.groupSummaryItems !== undefined && gridCell.groupSummaryItems.length > 0) {
                            excelCell.value = gridCell.groupSummaryItems[0].value?.toString();
                        }
                    }

                    if (gridCell.rowType === 'header' || gridCell.rowType === 'group' || gridCell.rowType === 'groupFooter' || gridCell.rowType === 'totalFooter') {
                        excelCell.font.bold = true;
                        excelCell.font.color = { argb: default_headfoot_font_colour, isDefault: true };

                        if (isGlReport) {
                            if (gridCell.rowType === 'header') {
                                excelCell.border = { bottom: { style: 'medium', color: { argb: 'black' } } };
                            }
                        }
                        else {
                            excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: default_headfoot_colour }, isDefault: true };
                        }
                    }

                    if (gridCell.rowType === 'header') {
                        excelCell.alignment = { horizontal: column.titleAlignment };
                    }

                    if (gridCell.rowType === 'data') {
                        if (rowNumber === -1 || rowNumber !== excelCell.fullAddress.row) {
                            rowIndex++;
                            rowNumber = excelCell.fullAddress.row;
                        }

                        if (!isGlReport) {
                            if (rowIndex % 2 == 0) {
                                excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: default_report_colour }, isDefault: true };
                            }
                            else {
                                excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: default_report_odd_colour }, isDefault: true };
                            }
                        }

                        if (isGlReport) {
                            if (gridCell.data && gridCell.data.length > 0) {
                                let collapsed = false;
                                for (var i = 0; i < gridCell.data.length; i++) {
                                    let val = gridCell.data[i];
                                    if (val && val.text !== undefined) {
                                        val = `${val.toString()}`;
                                    }

                                    if (val && typeof val === "string") {
                                        if (val.includes("<!--collapse-->")) {
                                            collapsed = true;
                                            if (typeof excelCell.fullAddress.row === "number") {
                                                //Remove group header when subtotal is bottom
                                                if (subtotalsPosition === TotalsPositionEnum.Bottom) {
                                                    if (rowsToReplaceSubtotalText.indexOf(`${subTotalText} ${val}`) === -1) {
                                                        rowsToReplaceSubtotalText.push(`${subTotalText} ${val}`);
                                                    }


                                                    if (rowsToRemove.indexOf(excelCell.fullAddress.row - 1) === -1) {
                                                        rowsToRemove.push(excelCell.fullAddress.row - 1);
                                                    }
                                                }

                                                if (rowsToRemove.indexOf(excelCell.fullAddress.row) === -1) {
                                                    rowsToRemove.push(excelCell.fullAddress.row);
                                                }
                                            }
                                        }
                                        else if (collapsed) {

                                            if (rowsCollapsed.indexOf(val) === -1) {
                                                //Need to remove subgroups
                                                rowsCollapsed.push(val);                                                
                                                rowsCollapsed.push(`${subTotalText} ${val}`);
                                                if (val && typeof val === "string") {
                                                    let replacedValue = replaceBasicHtmlContent(val);
                                                    rowsCollapsed.push(replacedValue);
                                                    rowsCollapsed.push(`${subTotalText} ${replacedValue}`);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else if (gridCell.rowType === 'group') {
                        groupIndex = gridCell.groupIndex;

                        if (gridCell.value) {
                            let groupValue = "";

                            groupValue = gridCell.value[0];
                            if (gridCell.value.text !== undefined) {
                                groupValue = `${gridCell.value.toString()}`;
                            }

                            if (subtotalsPosition === TotalsPositionEnum.Top && showReportRowCount) {
                                let summary = gridCell.groupSummaryItems?.find(function (x) { return x.name === "ForSubTotal"; });
                                //let countText = summary ? summary.value : "";
                                //text = `${text}${countText}`;
                                if (summary && summary.value) {
                                    groupValue = summary.value;
                                }
                            }

                            excelCell.value = groupValue;
                        }
                        else if (column.isMetric && subtotalsPosition !== TotalsPositionEnum.Top) {
                            excelCell.value = "";
                        }
                    }
                    else if (gridCell.rowType === 'totalFooter' && excelCell.value) {
                        excelCell.value = excelCell.value.replace(ReportWidget.tagLinkDrilldown, "");
                    }

                    if (gridCell.rowType === 'data' || gridCell.rowType === 'group' || gridCell.rowType === 'groupFooter' || gridCell.rowType === 'totalFooter') {
                        if (column.backgroundColor && column.backgroundColor !== "" && column.backgroundColor.toLowerCase() !== "#ffffff") {
                            excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: column.backgroundColor.replace("#", "") } };
                        }

                        if (column.foreColor && column.foreColor !== "") {
                            excelCell.font.color = { argb: column.foreColor.replace("#", "") };
                        }

                        if (column.isMetric) {
                            let value = gridCell.value;
                            if (!value && gridCell.groupSummaryItems && gridCell.groupSummaryItems.length > 0) {
                                value = gridCell.groupSummaryItems[0].value;
                            }

                            if (gridCell.rowType !== 'data' && excelCell.value !== "" && excelCell.value !== undefined) {
                                excelCell.value = value;
                            }

                            if (column.thresholdColor && column.thresholdValue !== undefined &&
                                column.thresholdValue !== null && value < column.thresholdValue) {
                                excelCell.font.color = { argb: column.thresholdColor.replace("#", "") };
                            }

                            let formattingRule = formattingRules.find(function (x) { return x.id === column.formattingRuleId; });
                            if (formattingRule) {
                                let isPercent = gridCell.column.format && column.format.style === "percent";
                                let formattingScale = FormattingRuleService.getFormattingRuleScale(formattingRule, value, isPercent);
                                if (cellsToApplyFormattingRule[excelCell.fullAddress.row]) {
                                    let cellsToApply = cellsToApplyFormattingRule[excelCell.fullAddress.row];
                                    if (formattingRule.config.applyRow) {
                                        cellsToApply.formattingRuleScale.push(formattingScale);
                                    }

                                    cellsToApply.cells[cellsToApply.cells.length - 1].formattingRuleScale = formattingScale;
                                }

                                applyFormattingRule(formattingScale, excelCell);
                            }

                            let xColumn = gridCell.column as any;
                            if (columns) {
                                xColumn = columns.find(x => x.queryName === column.queryName) || gridCell.column;
                            }
                            excelCell.style.numFmt = xColumn.excelNumberFormat;
                        }
                    }

                    if (isGlReport) {
                        if (gridCell.rowType === 'group' || gridCell.rowType === 'groupFooter') {
                            if (typeof excelCell.fullAddress.row === "number" && rowsCollapsed.indexOf(gridCell.value) !== -1 && rowsToRemove.indexOf(excelCell.fullAddress.row) === -1) {
                                rowsToRemove.push(excelCell.fullAddress.row);
                            }

                            if (subtotalsPosition === TotalsPositionEnum.Bottom && gridCell.rowType === 'group' && excelCell.value && excelCell.value != "" && typeof excelCell.value === "string" &&
                                excelCell.value.includes("<!--collapse-->") && rowsToRemove.indexOf(excelCell.fullAddress.row) === -1) {
                                rowsToRemove.push(excelCell.fullAddress.row);
                            }

                            if (gridCell.rowType === 'groupFooter') {
                                excelCell.border = { top: borderStyle, bottom: borderStyle };

                                if (gridCell.totalSummaryItemName === "ForSubTotal" && rowsToReplaceSubtotalText.indexOf(gridCell.value) !== -1 &&
                                    excelCell.value && excelCell.value != "" && typeof excelCell.value === "string") {
                                    excelCell.value = excelCell.value.replace(`${subTotalText} `, "");

                                    groupIndex--;
                                }
                            }

                            if (subtotalsPosition === TotalsPositionEnum.Top && gridCell.rowType === 'group') {
                                if (gridCell.value?.text && typeof gridCell.value.text === "string" && gridCell.value.text.includes("<!--collapse-->")) {
                                    rowsToApplyBorderWhenSubTotalIsTop.push(excelCell.fullAddress.row);
                                }
                            }
                        }
                    }

                    if (excelCell.value && excelCell.value != "" && typeof excelCell.value === "string") {
                        excelCell.value = replaceBasicHtmlContent(excelCell.value);
                        excelCell.value = addIdentation(excelCell.value, groupIndex);
                    }
                }
            }).then((cellRange) => {
                for (var rowIdx in cellsToApplyFormattingRule) {
                    let obj = cellsToApplyFormattingRule[rowIdx];
                    if (obj.formattingRuleScale.length) {
                        for (let f = 0; f < obj.formattingRuleScale.length; f++) {
                            let formattingRuleScale = obj.formattingRuleScale[f];

                            for (var i = 0; i < obj.cells.length; i++) {
                                applyFormattingRule(formattingRuleScale, obj.cells[i].excelCell);

                                if (obj.cells[i].formattingRuleScale) {
                                    applyFormattingRule(obj.cells[i].formattingRuleScale, obj.cells[i].excelCell, true);
                                }
                            }
                        }
                    }
                }

                for (let r of rowsToApplyBorderWhenSubTotalIsTop) {
                    let row = worksheet.getRow(r);
                    for (let col = 1; col <= worksheet.columnCount; col++) {
                        const cell = row.getCell(col); 
                        cell.border = { bottom: borderStyle };
                    }
                }

                //sort and distinct
                rowsToRemove = [...new Set(rowsToRemove)]
                for (let r = rowsToRemove.length - 1; r >= 0; r--) {
                    worksheet.spliceRows(rowsToRemove[r], 1);
                }

                if (!settings.withoutHeaders) {
                    for (var i = 1; i < worksheet.columnCount + 1; i++) {
                        var c = worksheet.getRow(1);
                        c.getCell(i).value = '';
                    }
                
                    const printedRow = worksheet.getRow(1);
                    printedRow.getCell(1).value = `Printed On:`;
                    printedRow.getCell(1).font = { bold: true };
                    printedRow.getCell(2).value = settings.printMessage;

                    let rowIndex = 2;
                    if (settings.companyName && settings.companyName !== "") {
                        const companyRow = worksheet.getRow(rowIndex);
                        companyRow.getCell(1).value = `Company:`;
                        companyRow.getCell(1).font = { bold: true };
                        companyRow.getCell(2).value = settings.companyName;
                        rowIndex++;
                    }

                    const mappingRow = worksheet.getRow(rowIndex);
                    mappingRow.getCell(1).value = `Mapping:`;
                    mappingRow.getCell(1).font = { bold: true };
                    mappingRow.getCell(2).value = settings.mappingName;
                    rowIndex++

                    const workbookRow = worksheet.getRow(rowIndex);
                    workbookRow.getCell(1).value = `Workbook:`;
                    workbookRow.getCell(1).font = { bold: true };
                    workbookRow.getCell(2).value = settings.workbookName;
                    rowIndex++

                    const tabRow = worksheet.getRow(rowIndex);
                    tabRow.getCell(1).value = `Tab:`;
                    tabRow.getCell(1).font = { bold: true };
                    tabRow.getCell(2).value = settings.tabName;
                    rowIndex++

                    if (settings.widgetName) {
                        const widgetRow = worksheet.getRow(rowIndex);
                        widgetRow.getCell(1).value = `Widget:`;
                        widgetRow.getCell(1).font = { bold: true };
                        widgetRow.getCell(2).value = settings.widgetName;
                        rowIndex++
                    }

                    const reportRow = worksheet.getRow(rowIndex);
                    reportRow.getCell(1).value = `Analyze By:`;
                    reportRow.getCell(1).font = { bold: true };
                    reportRow.getCell(2).value = settings.reportName + settings.analyzeByTop;
                    rowIndex++;

                    if (settings.groupBy) {
                        const groupByRow = worksheet.getRow(rowIndex);
                        groupByRow.getCell(1).value = `Group By:`
                        groupByRow.getCell(1).font = { bold: true };
                        groupByRow.getCell(2).value = settings.groupBy + settings.groupByTop;
                        rowIndex++;
                    }

                    if (settings.orderBy) {
                        const orderByRow = worksheet.getRow(rowIndex);
                        orderByRow.getCell(1).value = `Order By:`;
                        orderByRow.getCell(1).font = { bold: true };
                        orderByRow.getCell(2).value = settings.orderBy;
                        rowIndex++;
                    }

                    settings.filters.forEach(function (f) {
                        const filterRow = worksheet.getRow(rowIndex);
                        filterRow.getCell(1).value = `${f.name}:`;
                        filterRow.getCell(1).font = { bold: true };
                        filterRow.getCell(2).value = `${f.value}`;
                        rowIndex++;
                    });
                }
            }).then(() => {
                if (totalItemsUpdated) {
                    component.option("summary.totalItems", totalItems);
                }

                if (settings.isCSV) {
                    workbook.csv.writeBuffer().then((buffer) => {
                        if (settings.save) {
                            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${settings.fileName}.csv`);
                        }
                        else {
                            def.resolve(buffer.toString('base64'));
                        }
                    });
                }
                else {
                    workbook.xlsx.writeBuffer().then((buffer) => {
                        if (settings.save) {
                            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${settings.fileName}.xlsx`);
                        }
                        else {
                            def.resolve(buffer.toString('base64'));
                        }
                    });
                }
            });
        };

        if (totalItems !== null && totalItems !== undefined && totalItems.length > 0 && totalItems.filter(function (x) { return !x.hasBarChart; }).length > 0) {
            totalItemsUpdated = true;
            let totalItemsWhitoutBarChart = totalItems.filter(function (x) { return !x.hasBarChart; }).slice();
            component.option("summary.totalItems", totalItemsWhitoutBarChart);

            let looping = setInterval(function () {
                if (component.isReady()) {
                    clearInterval(looping);
                    customExport();
                }
            }, 100);
        }
        else {
            customExport();
        }

        return def;
    };

    var exportPivotToExcel = function (e, pivotComponent = null, context = null) {
        let settings = {
            isCSV: false,
            withoutHeaders: false,
            printMessage: "",
            mappingName: "",
            workbookName: "",
            tabName: "",
            widgetName: "",
            reportName: "",
            groupBy: "",
            orderBy: "",
            filters: "" as any,
            companyName: "",
            fontSize: 0,
            glReport: false,
            subtotalsPosition: TotalsPositionEnum.None,
            subTotalText: "",
            save: false,
            fileName: "",
            currencyCode: "",
            formattingRules: undefined,
            analyzeByTop: "",
            groupByTop: "",
            separateFields: false
        };
        $.extend(settings, e);

        //file name has a limit of 31 characteres
        const fileName = settings.reportName?.length > 30 ? settings.reportName.substring(0, 29) : settings.reportName;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(fileName);
        const component = pivotComponent || $('.gridContainer').data("dxPivotGrid");
        let def = $.Deferred();
        let skip = 1;
        if (!settings.withoutHeaders) {
            skip = 6;
            if (settings.widgetName) {
                skip++;
            }
            if (settings.groupBy) {
                skip++;
            }
            if (settings.orderBy) {
                skip++;
            }
            if (settings.companyName && settings.companyName !== "") {
                skip++;
            }

            if (typeof settings.filters === "string" && settings.filters !== "") {
                settings.filters = JSON.parse(settings.filters);
                skip += settings.filters.length;
            }
            else {
                if (settings.filters === "" || settings.filters === undefined || settings.filters === null)
                    settings.filters = [];

                skip += settings.filters.length;
            }
        }

        let result = {} as any;
        let widget = context ? $("widget", context) : $("widget");
        if (widget.length) {
            result = ko.dataFor(widget.get(0))?.widget?.result;
        }

        let formattingRules = result.formattingRules || settings.formattingRules;
        let isGlReport = result.glReport || settings.glReport;
        let currencyCode = result.currencyCode || settings.currencyCode;
        let columns = component.option("dataSource.fields");
        setExcelColumnFormat(columns, currencyCode);

        let default_headfoot_font_colour = $("html").css("--default_headfoot_font_colour").replace("#", "").trimStart();
        let default_headfoot_colour = $("html").css("--default_headfoot_colour").replace("#", "").trimStart();
        let addBorderToRow = [];
        const borderStyle = { style: 'thin', color: { argb: 'black' } };
        const borderStyleThin = { style: 'thin', color: { argb: 'E0E0E0' } };

        let cellsToApplyFormattingRule = {};
        let applyFormattingRule = function (formattingScale, excelCell) {
            let colors = getFormattingScaleColor(formattingScale);
            if (colors.backgroundColor && colors.backgroundColor.toLowerCase() !== "#ffffff") {
                excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: colors.backgroundColor.replace("#", "") } };
            }
            if (colors.color) {
                excelCell.font.color = { argb: colors.color.replace("#", "") };
            }
        }.bind(this)
        DevExpress.excelExporter.exportPivotGrid({
            component: component,
            worksheet,
            exportRowFieldHeaders: true,
            exportColumnFieldHeaders: true,
            exportDataFieldHeaders: true,
            topLeftCell: { row: skip, column: 1 },
            customizeCell(options) {
                const { pivotCell } = options;
                const { excelCell } = options;
                excelCell.font = excelCell.font || {};
                excelCell.font.size = settings.fontSize;                

                let isTotalCell = PivotWidget.isTotalCell(pivotCell);
                if (PivotWidget.isDataCell(pivotCell) || isTotalCell) {
                    const field = PivotWidget.getField(component, pivotCell);
                    if (field && field.isMetric) {
                        if (!settings.isCSV) {
                            if (!cellsToApplyFormattingRule[excelCell.row]) {
                                cellsToApplyFormattingRule[excelCell.row] = {
                                    formattingRuleScale: null,
                                    cells: []
                                };
                            }

                            cellsToApplyFormattingRule[excelCell.row].cells.push({ pivotCell, excelCell });
                        }

                        if (pivotCell.value !== undefined && isNaN(pivotCell.value)) {
                            pivotCell.value = null;
                            excelCell.value = null;
                        }
                    }

                    if (field && field.isMetric && pivotCell.value !== null && pivotCell.value !== undefined) {
                        if (isTotalCell) {
                            excelCell.font.color = { argb: default_headfoot_font_colour };
                            excelCell.font.bold = true;
                            excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: isGlReport ? "FFFFFF" : default_headfoot_colour } };
                        }

                        if (field.backgroundColor && field.backgroundColor !== "" && field.backgroundColor.toLowerCase() !== "#ffffff") {
                            excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: field.backgroundColor.replace("#", "") } };
                        }

                        if (field.foreColor && field.foreColor !== "") {
                            excelCell.font.color = { argb: field.foreColor.replace("#", "") };
                        }

                        if (field.thresholdColor && field.thresholdValue !== undefined &&
                            field.thresholdValue !== null && pivotCell.value < field.thresholdValue) {
                            excelCell.font.color = { argb: field.thresholdColor.replace("#", "") };
                        }

                        let formattingRule = formattingRules.find(function (x) { return x.id === field.formattingRuleId; });
                        if (formattingRule) {
                            let isPercent = field.format && field.format.style === "percent";
                            let formattingScale = FormattingRuleService.getFormattingRuleScale(formattingRule, pivotCell.value, isPercent);
                            if (cellsToApplyFormattingRule[excelCell.row]) {
                                if (formattingRule.config.applyRow) {
                                    cellsToApplyFormattingRule[excelCell.row].formattingRuleScale = formattingScale;
                                }
                                else {
                                    cellsToApplyFormattingRule[excelCell.row].cells[cellsToApplyFormattingRule[excelCell.row].cells.length - 1].formattingRuleScale = formattingScale;
                                }
                            }

                            applyFormattingRule(formattingScale, excelCell);
                        }

                        let column = field;
                        if (columns) {
                            column = columns.find(x => x.queryName === field.queryName) || field;
                        }
                        excelCell.style.numFmt = column.excelNumberFormat;
                    }
                    else {
                        excelCell.font.color = { argb: default_headfoot_font_colour };
                        excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: isGlReport || !isTotalCell ? "FFFFFF" : default_headfoot_colour } };

                        if (pivotCell.type === "T" || pivotCell.type === "GT")
                            excelCell.font.bold = true;
                    }
                }
                else {
                    excelCell.font.color = { argb: default_headfoot_font_colour };
                    excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: isGlReport || (pivotCell.type === 'D' && pivotCell.area === "row") ? "FFFFFF" : default_headfoot_colour } };
                    if (pivotCell.expanded === true || pivotCell.expanded === false || pivotCell.type === "T" || pivotCell.type === "GT" || pivotCell.area === "column") {
                        excelCell.font.bold = true;
                    }
                }

                if (!excelCell.border) {
                    excelCell.border = {
                        bottom: borderStyleThin,
                        left: borderStyleThin,
                        right: borderStyleThin,
                        top: borderStyleThin,
                    };
                }

                if (isGlReport && (pivotCell.type === "T" || pivotCell.type === "GT" || pivotCell.rowType === "T" || pivotCell.rowType === "GT" || pivotCell.expanded === false)) {
                    addBorderToRow.push(excelCell.row);
                }

                if (excelCell.value && excelCell.value != "" && typeof excelCell.value === "string") {
                    excelCell.value = replaceBasicHtmlContent(excelCell.value);
                }

                if (settings.separateFields) {
                    if (pivotCell.type === 'T') {
                        excelCell.value = replaceBasicHtmlContent(`${settings.subTotalText} ${(pivotCell.path[pivotCell.path.length - 1] as any).totalTextSeparateFields}`);
                    }

                    if (pivotCell.type === 'D' && pivotCell.area === "row") {
                        let field = PivotWidget.getFieldByArea(component, pivotCell);
                        if (field) {
                            if (field.showTotals === false) {
                                excelCell.font.bold = false;
                            }
                        }
                    }
                }
            }
        }).then((cellRange) => {
            for (var rowIdx in cellsToApplyFormattingRule) {
                if (cellsToApplyFormattingRule[rowIdx].formattingRuleScale) {
                    for (var i = 0; i < cellsToApplyFormattingRule[rowIdx].cells.length; i++) {
                        applyFormattingRule(cellsToApplyFormattingRule[rowIdx].formattingRuleScale, cellsToApplyFormattingRule[rowIdx].cells[i].excelCell);

                        if (cellsToApplyFormattingRule[rowIdx].cells[i].formattingRuleScale) {
                            applyFormattingRule(cellsToApplyFormattingRule[rowIdx].cells[i].formattingRuleScale, cellsToApplyFormattingRule[rowIdx].cells[i].excelCell);
                        }
                    }
                }
            }

            for (var i = 0; i < addBorderToRow.length; i++) {
                let row = worksheet.getRow(addBorderToRow[i]);
                for (var c = 1; c <= row.cellCount; c++) {
                    row.getCell(c).border = {
                        bottom: borderStyle,
                        top: borderStyle,
                        right: borderStyleThin,
                        left: borderStyleThin
                    };
                }
            }

            if (!settings.withoutHeaders) {
                for (var i = 1; i < worksheet.columnCount + 1; i++) {
                    var r = worksheet.getRow(1);
                    r.getCell(i).value = '';
                }
            
                const printedRow = worksheet.getRow(1);
                printedRow.getCell(1).value = `Printed On:`;
                printedRow.getCell(1).font = { bold: true };
                printedRow.getCell(2).value = settings.printMessage;

                let rowIndex = 2;
                if (settings.companyName && settings.companyName !== "") {
                    const companyRow = worksheet.getRow(rowIndex);
                    companyRow.getCell(1).value = `Company:`;
                    companyRow.getCell(1).font = { bold: true };
                    companyRow.getCell(2).value = settings.companyName;
                    rowIndex++;
                }

                const mappingRow = worksheet.getRow(rowIndex);
                mappingRow.getCell(1).value = `Mapping:`;
                mappingRow.getCell(1).font = { bold: true };
                mappingRow.getCell(2).value = settings.mappingName;
                rowIndex++;

                const workbookRow = worksheet.getRow(rowIndex);
                workbookRow.getCell(1).value = `Workbook:`;
                workbookRow.getCell(1).font = { bold: true };
                workbookRow.getCell(2).value = settings.workbookName;
                rowIndex++;

                const tabRow = worksheet.getRow(rowIndex);
                tabRow.getCell(1).value = `Tab:`;
                tabRow.getCell(1).font = { bold: true };
                tabRow.getCell(2).value = settings.tabName;
                rowIndex++;

                if (settings.widgetName) {
                    const widgetRow = worksheet.getRow(rowIndex);
                    widgetRow.getCell(1).value = `Widget:`;
                    widgetRow.getCell(1).font = { bold: true };
                    widgetRow.getCell(2).value = settings.widgetName;
                    rowIndex++
                }

                const reportRow = worksheet.getRow(rowIndex);
                reportRow.getCell(1).value = `Analyze By:`;
                reportRow.getCell(1).font = { bold: true };
                reportRow.getCell(2).value = settings.reportName + settings.analyzeByTop;
                rowIndex++;

                if (settings.groupBy) {
                    const groupByRow = worksheet.getRow(rowIndex);
                    groupByRow.getCell(1).value = `Pivot On:`
                    groupByRow.getCell(1).font = { bold: true };
                    groupByRow.getCell(2).value = settings.groupBy + settings.groupByTop;
                    rowIndex++;
                }

                if (settings.orderBy) {
                    const orderByRow = worksheet.getRow(rowIndex);
                    orderByRow.getCell(1).value = `Order By:`;
                    orderByRow.getCell(1).font = { bold: true };
                    orderByRow.getCell(2).value = settings.orderBy;
                    rowIndex++;
                }

                settings.filters.forEach(function (f) {
                    const filterRow = worksheet.getRow(rowIndex);
                    filterRow.getCell(1).value = `${f.name}`;
                    filterRow.getCell(1).font = { bold: true };
                    filterRow.getCell(2).value = `${f.value}`;
                    rowIndex++;
                });
            }
        }).then(() => {
            if (settings.isCSV) {
                workbook.csv.writeBuffer().then((buffer) => {
                    if (settings.save) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${settings.fileName}.csv`);
                    }
                    else {
                        def.resolve(buffer.toString('base64'));
                    }
                });
            }
            else {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    if (settings.save) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${settings.fileName}.xlsx`);
                    }
                    else {
                        def.resolve(buffer.toString('base64'));
                    }
                });
            }
        });

        return def;
    };

    var getFormattingScaleColor = function(formattingScale) {
        let backgroundColor = null;
        let color = null;
        let iconColor = null;
        if (formattingScale !== null) {
            if (formattingScale.backgroundColor) {
                backgroundColor = formattingScale.backgroundColor;
            }

            if (formattingScale.fontColor) {
                color = formattingScale.fontColor;
            }

            if (formattingScale.color) {
                iconColor = formattingScale.color;
            }
        }

        return {
            backgroundColor: backgroundColor,
            color: color,
            iconColor: iconColor
        }
    }

    var exportToHtml = function (workbookId: number, tabId: number, suppressReportHeader: boolean, scheduledEmailId: number = null) {
        workbook.exportPrintSetup(workbookId, tabId, null, false, scheduledEmailId);
        workbook.workbookConfig.isPrinting = true;
        workbook.workbookConfig.isEmailBody = true;
        workbook.workbookConfig.suppressReportHeader = suppressReportHeader;

        let tab = workbook.workbookConfig.tabs().find(x => x.id() === tabId);

        let $widget = $("widget-html");
        if ($widget.length) {
            let result = getTab(tab, 0);
            let reportWidget = BaseWidget.createWidget(null, tab, null, result.widgetType);
            reportWidget.setResultAndConfig(result);
            ko.applyBindings({ config: workbook.workbookConfig, widget: reportWidget }, $widget.get(0));
        }
    };

    return {
        print,
        
        exportToPDF,
        exportToXLSXCSV,

        printDashboard,
        exportDashboardToPDF,

        exportWorkbookToPDF,

        exportReportToExcel,
        exportPivotToExcel,

        exportToHtml
    };
}
)();

function maxWidth(isDashboard = false) {
    let width = 0;

    //#infinite-scrollbar
    if (isDashboard) {
        let dashboard = $("dashboard");
        width = dashboard.get(0).scrollWidth;
    }
    else {
        for (let element of $('.gridContainer')) {
            if ($(element).closest("dashboard").length > 0) {
                continue;
            }

            if (element.scrollWidth > width) {
                width = element.scrollWidth;
            }

            $('.dx-datagrid-headers .dx-datagrid-scroll-container', element).each(function () {
                if (this.scrollWidth > width) {
                    width = this.scrollWidth;
                }
            });

            $('.dx-pivotgrid-container tr.dx-bottom-row', element).each(function () {
                let rowCell = $(".dx-area-row-cell", this).get(0).scrollWidth;
                let areaCell = $(".dx-area-data-cell .dx-scrollable-content", this).get(0).scrollWidth;
                let pivotWidth = rowCell + areaCell + 20;//20 padding + margin
                if (pivotWidth > width) {
                    width = pivotWidth;
                }
            });
        }
    }

    //$('.chartMainContainer') !== null && $('.chartMainContainer').each(function () {
    //    if (this.scrollWidth > width) {
    //        width = this.scrollWidth;
    //    }
    //});

    //$('.page') != null && $('.page').each(function () {
    //    if (this.scrollWidth > width) {
    //        width = this.scrollWidth;
    //    }
    //});

    if (width === 0 && $("#warningEditMode").length > 0) {
        width = $("#warningEditMode").width();
    }

    return width;
}

function setWorkbookWidth(maxWorkbookWidth) {
    let width = maxWidth() as any;
    if (width === 0) {
        $("html").css("width", `100%`);
    }
    else {
        if (width < maxWorkbookWidth) {
            width = maxWorkbookWidth;
        }

        $("html").css("width", `${width}px`);
    }
}

//drawnGrids
function reportsReady() {
    let grids = $(".gridContainer");
    let charts = $(".canvasChart");
    let items = grids.length + charts.length;
    let readyItems = 0;

    grids.each(function () {
        let ready = true;
        let grid = $(this).data("dxDataGrid");
        if (grid) {
            ready = grid.isReady();
        }

        let pivot = $(this).data("dxPivotGrid");
        if (pivot && ready) {
            ready = pivot.isReadyIR;
        }

        if (ready) {
            readyItems++;
        }
    });

    charts.each(function () {
        let ready = true;
        let pie = $(this).data("dxPieChart");
        if (pie) {
            ready = pie.isReady();
        }

        let polar = $(this).data("dxPolarChart");
        if (polar && ready) {
            ready = polar.isReady();
        }

        let chart = $(this).data("dxChart");
        if (chart && ready) {
            ready = chart.isReady();
        }

        if (ready) {
            readyItems++;
        }
    });

    return readyItems === items;
}

function repaintGrids() {
    let grids = $('.gridContainer');
    grids.each(function () {
        let grid = $(this).data("dxDataGrid");
        if (grid) {
            grid.refresh();
        }

        let pivot = $(this).data("dxPivotGrid");
        if (pivot) {
            pivot.repaint();
        }
    });
}

function setExcelColumnFormat(columns, currencyCode) {
    if (columns) {
        var dx = DevExpress as any;
        var currencySymbol = dx.formatHelper.format(0, {
            style: "currency",
            currency: currencyCode,
            currencyDisplay: "narrowSymbol",
            precision: 0
        }).replace("0", "");

        columns.forEach(function (column) {
            if (column.isMetric) {
                let format = "#,##0";
                if (column.format.precision > 0) {
                    format += ".";
                    for (var i = 0; i < column.format.precision; i++) {
                        format += "0";
                    }
                }

                switch (column.format.style) {
                    case "currency":
                        format = `${currencySymbol}${format}`;
                        break
                    case "percent":
                        format = `${format}%`;
                        break
                    default:
                        break
                }

                if (column.format.currencySign === "accounting") {
                    format = `${format};(${format})`;
                }

                column.excelNumberFormat = format;
            }
        });
    }
}